import React from 'react'
export const initWDYR = () => {
  if (process.env.NODE_ENV === 'development' && process.env.WDYR) {
    console.log('wdyr init')

    const whyDidYouRender = require('@welldone-software/why-did-you-render')

    whyDidYouRender(React, {
      trackAllPureComponents: true,
    })
  }
}
